// Useful constants at init time (before getting GL context)

export const NEAREST = 0x2600;
export const LINEAR = 0x2601; // 9729
export const NEAREST_MIPMAP_NEAREST = 0x2700;
export const LINEAR_MIPMAP_NEAREST = 0x2701;
export const NEAREST_MIPMAP_LINEAR = 0x2702;
export const LINEAR_MIPMAP_LINEAR = 0x2703;

export const CLAMP = 0x2900;
export const REPEAT = 0x2901; // 10497
export const CLAMP_TO_EDGE = 0x812F; // 33071